var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.access)?_c('keep-alive',{attrs:{"include":['Feed', 'UserListing']}},[_c(_vm.component,{tag:"Component"})],1):_c(_vm.component,{tag:"Component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }